<div class="select-file-container" [ngClass]="fileSelectConfig.styles?.containerClass">
  @if(isImageFile()) {
    <div class="image-upload-container">
      <div [matTooltip]="fileSelectConfig.fileName ?? ''"
           class="image-thumbnail rounded cursor-pointer"
           [ngClass]="{ 'img-drop-bg': isDraggingOver }"
           (dragover)="!disabled && handleDragOver($event)"
           (click)="openImage($event)"
           (dragleave)="!disabled && handleDragLeave($event)"
           (drop)="!disabled && onDrop($event)">
        <input type="file" (change)="onFileSelect($event)" class="d-none" #fileInput [accept]="fileSelectConfig.fileType" />
        <img [src]="fileSelectConfig.fileUri ?? './assets/images/common/no-img.png'"
          [alt]="fileSelectConfig.fileName"
          [width]="fileSelectConfig.width"
          class="thumbnail rounded"
          [ngClass]="{ 'cursor-pointer': fileSelectConfig.fileUri }"/>
      </div>
      @if (fileSelectConfig.fileUri) {
        <i-tabler (click)="clearFile($event, fileInput)" name="trash" class="icon-20 d-flex" [ngStyle]="{ visibility: disabled ? 'hidden' : 'visible'}"/>
      }
    </div>
  } @else {
    <div class="d-flex cursor-pointer file-upload-container"
      [ngStyle]="{ padding: fileSelectConfig.fileName ? '7px 14px' : '10px 14px'}" 
      (click)="!disabled && fileInput.click()">
      <!-- control icon -->
      <img src="{{fileSelectConfig.fileName ? '/assets/images/common/file.svg' : '/assets/images/common/upload.svg'}}" [width]="20" class="m-r-8"/>      
      <!-- file infomation -->
      <div class="file-preview">
        @if (!fileSelectConfig.fileName){
          <span>{{ "choose file" | translate }}</span>
        } @else {
          <div class="file-info">
            <p class="m-0 f-s-12 f-w-500 text-truncate" [ngClass]="{ 'mat-secondary': disabled }">{{ fileSelectConfig.fileName }}</p>
            <p class="m-0 f-s-10 text-truncate">{{ fileSelectConfig.fileSize }}</p>
          </div>
        }
        <input type="file" (change)="onFileSelect($event)" class="d-none" #fileInput [accept]="fileSelectConfig.fileType" />
      </div>
      <!-- File action -->
      <div class="d-flex gap-2">
        @if (fileSelectConfig.fileUri) {
          <i-tabler (click)="clearFile($event, fileInput)" name="trash" class="d-flex m-r-4" [ngStyle]="{ visibility: disabled ? 'hidden' : 'visible'}" />
          <i-tabler (click)="onDownloadFile($event)" name="download" class="d-flex" [ngStyle]="{ visibility: disabled ? 'hidden' : 'visible'}"/>
        }
      </div>
    </div>
  }
</div>
